// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OaZG","image":"Header_image__xGJE_","name":"Header_name__10Zyj","info":"Header_info__SskRs","infoRow":"Header_infoRow__TeaKm"};